<div class="box-dialog-wrapper">
  <box-dialog-header [title]="title" class="box-dialog-header" (closeDialog)="closeDialog()"></box-dialog-header>
  <main class="box-dialog-content">
    <section class="home-section-info-dialog-section">
      <div class="home-section-info-dialog-description" [innerHTML]="htmlContent"></div>
    </section>
  </main>
</div>
